import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { Ticker } from '../Ticker';

export interface IPikPromoBannerProps {
  onClick(): void;
  disclaimer: string | null;
  hitUrl: string;
}

const MOBILE_IMAGE_URL =
  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/mainpage/promo-banner-mobile.png';
const TABLET_IMAGE_URL =
  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/mainpage/promo-banner-tablet.png';

export function PikPromoBanner({ onClick, disclaimer, hitUrl }: IPikPromoBannerProps) {
  return (
    <div className={styles['container']}>
      <a data-testid="hitUrl" href={hitUrl} className={styles['promo-block']} onClick={onClick}>
        <picture>
          <source media="(min-width: 640px)" srcSet={TABLET_IMAGE_URL} />
          {/* eslint-disable-next-line react/no-unknown-property */}
          <img
            className={styles['promo-block-image']}
            src={MOBILE_IMAGE_URL}
            alt=""
            // @ts-expect-error fetchPriority is a valid HTML attribute not yet in @types/react
            fetchPriority="high"
          />
        </picture>
        <div className={styles['content']}>
          <UIText1 color="white_100" fontWeight="bold">
            Серия плюс
          </UIText1>
          <UIText2 color="white_100">
            Линейка проектов
            <br />с новым уровнем комфорта от ПИК
          </UIText2>
        </div>
        {disclaimer && (
          <div data-testid="disclaimer" className={styles['disclaimer']}>
            <Ticker text={disclaimer} />
          </div>
        )}
      </a>
    </div>
  );
}
